import React, { Component } from 'react';
import ReportPage from './ReportPage';
import Questions from '../../entities/questions.json';

export default class FullSummaryPage extends Component {
	getAnswer(qid, normalizeText){
        if (!this.props.responses)return null;
        let response = this.props.responses[qid];
        if (response){
            let text = response.selected ? (response.selected.text || response.selected.outputText) : null;
            if (!text)text = response.altSelected ? (response.altSelected.text || response.altSelected.outputText) : null;
            if (!text)return;
            text = text.replace('<br/>', ' ');
            if (normalizeText){
                let firsChar = text[0];
                text = firsChar.toLowerCase() + text.slice(1);
            }
            if (response.altNotes) {
                text = text + ' (notes: ' + response.altNotes + ')';
            }
            if (this.props.responses[qid]['twoDimensional'] && this.props.responses[qid]['selectedLeftColumn'] && this.props.responses[qid]['selectedRightColumn']) {
            	return <span className="emphasis" style={{float: "right", textAlign: "right"}}>{text}, previous objectives: {this.props.responses[qid]['selectedLeftColumn']}{this.props.responses[qid]['leftColumnNotes'] ? <span> ({this.props.responses[qid]['leftColumnNotes']})</span> : null}, new objectives: {this.props.responses[qid]['selectedRightColumn']}{this.props.responses[qid]['leftColumnNotes'] ? <span> ({this.props.responses[qid]['rightColumnNotes']})</span> : null}</span>
            } else {
            	return <span className="emphasis" style={{float: "right", textAlign: "right"}}>{text}</span>
            }
        }else{
            return null;
        }        
    }

    getQuestion(qid, normalizeText) {
    	if (!qid)return null;
    	let question = Questions[qid];
    	if (question) {
    		question = question['text'];
    		if (normalizeText) {
    			let firstChar = question[0];
    			question = firstChar.toLowerCase() + question.slice(1);
    		}
    		return <span>{question}</span>
    	} else {
    		return null;
    	}
    }

    getValue(qid){
        if (!this.props.responses)return null;
        return this.props.responses[qid];
    }

    getAltAnswer(qid, normalizeText){
        if (!this.props.responses)return null;
        let response = this.props.responses[qid];
        if (!response)return null;
        if (response.selected.text === 'No')return null;
        let altSelected = response.altSelected;
        if (response && altSelected){
            let text = altSelected.outputText || altSelected.text;
            if (text === "Other"){
                text = response.altOther || text;
            }
            //console.log(JSON.stringify(response));
            if (response.altNotes) {
                text = text + ' (notes: ' + response.altNotes + ')';
            }
            text = text.replace('<br/>', ' ');
            if (normalizeText){
                let firsChar = text[0];
                text = firsChar.toLowerCase() + text.slice(1);
            }
            return <span className="emphasis">{text}</span>
        }else{
            return null;
        }
        
    }  
    
    getTip(qid){
        let data = Questions[qid];
        return data.tip || '';
    }

    renderQuestionRow(index, min, max) {
    	if (index >= min && index <= max) {
    		if (Questions[index]) {
                //console.log('render ' + index)
    			return <div style={{backgroundColor: "lightgray", padding: "15px", borderRadius: "5px", fontSize: "10px", border: "1px solid white"}} className="answerSummaryText">{index}) {this.getQuestion(index)}<br /><div>{this.getAnswer(index)}</div><br /></div>;
    		} else {
    			return null;
    		}
    	} else {
    		return null;
    	}
    }

    getAnswerAddendum(qid){
        let response = this.props.responses[qid];
        if (!response)return null;
        let resp = <span className="highlight space-before">It may be necessary to consider replacing the fund.</span>;
        let respEm = <span className="emphasis">{resp}</span>;
        switch(qid){
            case 2: 
                return response.selected.text === 'Yes' ? resp : null;
            case 3: 
                return response.selected.text === 'Yes' ? resp: null;
            case 4: 
                return response.selected.id === '2' ? resp: null;
            case 5: 
                return response.selected.text === 'Yes' ? resp: null;                
            case 6: 
                return response.selected.text === 'Yes' ? respEm: null;
            case 7: 
                return response.selected.id !== '3' ? respEm: null;                
            default:
                return '';
        }
    }

    render() {
    	return [
	    	<ReportPage key={'qr1'} title={this.props.preparedFor + ' Answer Summary'} longSubtitle={true} addBreak={true} {...this.props} className="questionnaire-results" pageNumber={this.props.pageNumber}>
	    		<div style={{display: "flex"}}>
                    <div style={{width: "50%"}}>
                        {Object.keys(Questions).map((key, index) => this.renderQuestionRow(index+1, -1, 10))}
                    </div>
                    <div style={{width: "5%"}}></div>
                    <div style={{width: "50%"}}>
                        {Object.keys(Questions).map((key, index) => this.renderQuestionRow(index+1, 11, 19))}
                    </div>
                </div>
	    	</ReportPage>
    	]
    }
}